import React, { useEffect, useState } from "react";
import Styles from "./ConsumerDetails.module.css";
import DriveFileRenameOutlineIcon from "@mui/icons-material/DriveFileRenameOutline";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
} from "../../../commons/Accordion";
import { consumerDetails as consumerDetailsConfig } from "../../../commons/Profile";
import { useSelector, useDispatch } from "react-redux";
import { usePdfPreview } from "../../../hooks/usePdfPreview";
import { fetchConsumer } from "../../../Redux/Slices/companyAdminSlice";

// State mapping data
const stateData = [
  { id: 1, name: "Andhra Pradesh", label: "AP", isUt: false, regionId: 3 },
  { id: 2, name: "Arunachal Pradesh", label: "AR", isUt: false, regionId: 5 },
  { id: 3, name: "Assam", label: "AS", isUt: false, regionId: 5 },
  { id: 4, name: "Bihar", label: "BR", isUt: false, regionId: 4 },
  { id: 5, name: "Chandigarh", label: "CG", isUt: true, regionId: 1 },
  { id: 6, name: "Chhattisgarh", label: "CH", isUt: false, regionId: 2 },
  {
    id: 7,
    name: "Dadar Nagar Haveli & Daman diu",
    label: "DNH & DD",
    isUt: true,
    regionId: 2,
  },
  { id: 8, name: "Delhi", label: "DL", isUt: true, regionId: 1 },
  { id: 9, name: "DVC", label: "DVC", isUt: false, regionId: 4 },
  { id: 10, name: "Goa", label: "GA", isUt: false, regionId: 2 },
  { id: 11, name: "Gujarat", label: "GJ", isUt: false, regionId: 2 },
  { id: 12, name: "Haryana", label: "HR", isUt: false, regionId: 1 },
  { id: 13, name: "Himachal Pradesh", label: "HP", isUt: true, regionId: 1 },
  { id: 14, name: "Jammu & Kashmir", label: "JK", isUt: false, regionId: 1 },
  { id: 15, name: "Jharkhand", label: "JH", isUt: false, regionId: 4 },
  { id: 16, name: "Karnataka", label: "KA", isUt: false, regionId: 3 },
  { id: 17, name: "Kerala", label: "KL", isUt: false, regionId: 3 },
  { id: 18, name: "Madhya Pradesh", label: "MP", isUt: false, regionId: 2 },
  { id: 19, name: "Maharashtra", label: "MH", isUt: false, regionId: 2 },
  { id: 20, name: "Manipur", label: "MN", isUt: true, regionId: 5 },
  { id: 21, name: "Meghalaya", label: "ML", isUt: false, regionId: 5 },
  { id: 22, name: "Mizoram", label: "MZ", isUt: false, regionId: 5 },
  { id: 23, name: "Nagaland", label: "NL", isUt: false, regionId: 5 },
  { id: 24, name: "Odisha", label: "OD", isUt: false, regionId: 4 },
  { id: 25, name: "Puduchery", label: "PY", isUt: false, regionId: 3 },
  { id: 26, name: "Punjab", label: "PB", isUt: false, regionId: 1 },
  { id: 27, name: "Rajasthan", label: "RJ", isUt: false, regionId: 1 },
  { id: 28, name: "Sikkim", label: "SK", isUt: false, regionId: 4 },
  { id: 29, name: "Tamilnadu", label: "TN", isUt: false, regionId: 3 },
  { id: 30, name: "Telangana", label: "TS", isUt: false, regionId: 3 },
  { id: 31, name: "Tripura", label: "TR", isUt: true, regionId: 5 },
  { id: 32, name: "Uttar Pradesh", label: "UP", isUt: false, regionId: 1 },
  { id: 33, name: "Uttarakhand", label: "UK", isUt: false, regionId: 1 },
  { id: 34, name: "West Bengal", label: "WB", isUt: false, regionId: 4 },
];
const getStateName = (stateId) => {
  const state = stateData.find((state) => state.id === stateId);
  return state ? state.name : stateId;
};
const specificationData = [
  { id: 1, type: "GENERATOR", name: "Discom" },
  { id: 2, type: "GENERATOR", name: "Generator" },
  { id: 3, type: "GENERATOR", name: "IPP" },
  { id: 4, type: "GENERATOR", name: "Captive" },
  { id: 5, type: "GENERATOR", name: "Other" },
  { id: 6, type: "CONSUMER", name: "Discom" },
  { id: 7, type: "CONSUMER", name: "OA Consumer" },
  { id: 8, type: "CONSUMER", name: "Industrial" },
  { id: 9, type: "CONSUMER", name: "Other" },
];

const getSpecificationName = (specId) => {
  const spec = specificationData.find((item) => item.id === specId);
  return spec ? spec.name : specId;
};

const renderDetailElement = (
  detail,
  consumerData,
  handlePreviewGeneralTerms
) => {
  let actualValue;

  if (detail?.addressType === "office" && consumerData?.consumerOfficeAddress) {
    actualValue = consumerData.consumerOfficeAddress[detail?.value];
  } else if (
    detail?.addressType === "correspondence" &&
    consumerData?.consumerCorrespondenceAddress
  ) {
    actualValue = consumerData.consumerCorrespondenceAddress[detail?.value];
  } else if (
    detail?.addressType === "bank" &&
    consumerData?.consumerBankDetails
  ) {
    actualValue = consumerData.consumerBankDetails[detail?.value];
  } else if (
    detail?.addressType === "discom" &&
    consumerData?.discomDetails &&
    consumerData.discomDetails.length > 0
  ) {
    actualValue = consumerData.discomDetails[0][detail?.value];
  } else if (
    (detail?.value?.includes("DocId") || detail?.value?.includes("Document")) &&
    consumerData?.consumerDocuments
  ) {
    actualValue = consumerData.consumerDocuments[detail?.value];
  } else {
    actualValue = consumerData ? consumerData[detail?.value] : undefined;
  }

  const getStateName = (stateId) => {
    const state = stateData.find((state) => state.id === stateId);
    return state ? state.name : stateId;
  };

  const getSpecificationName = (specId) => {
    const spec = specificationData.find((item) => item.id === specId);
    return spec ? spec.name : specId;
  };

  let displayValue;
  if (detail?.value === "stateUtId") {
    displayValue = getStateName(actualValue);
  } else if (detail?.value === "specificationId") {
    displayValue = actualValue
      ? getSpecificationName(actualValue)
      : detail.defaultValue || "-";
  } else {
    displayValue =
      actualValue !== undefined &&
      actualValue !== null &&
      actualValue !== "" &&
      actualValue !== "NA"
        ? actualValue
        : detail.defaultValue || "-";
  }

  if (detail?.disp === "0") {
    return (
      <div className={Styles.eachDetailElement}>
        <div>{detail?.header}</div>
        <div>{displayValue}</div>
      </div>
    );
  }
  if (detail?.disp === "1") {
    return (
      <div className={Styles.eachDetailElement1}>
        <div>{detail?.header}</div>
        <div>{displayValue}</div>
      </div>
    );
  }
  if (detail?.disp === "2") {
    console.log("Document field debug:", {
      header: detail?.header,
      value: detail?.value,
      actualValue: actualValue,
      consumerData: consumerData,
    });
    return (
      <div className={Styles.eachDetailElement}>
        <div>{detail?.header}</div>
        {actualValue ? (
          <div
            className={`display_flex_row_gap_8_only ${Styles.viewDoc}`}
            style={{ cursor: "pointer" }}
            onClick={() => {
              console.log(
                "Clicking view button with actualValue:",
                actualValue
              );
              handlePreviewGeneralTerms(actualValue);
            }}
          >
            <span>View</span>
            <RemoveRedEyeIcon style={{ fontSize: "12px" }} />
          </div>
        ) : (
          <div>
            <span style={{ color: "#999" }}>{detail.defaultValue || "-"}</span>
          </div>
        )}
      </div>
    );
  }
  return null;
};

const renderDetailSection = (
  heading,
  details,
  consumerData,
  handlePreviewGeneralTerms
) => {
  return (
    <>
      <div className={Styles.insiderHeading}>{heading}</div>
      <div className={Styles.eachDetailElementMainContainer}>
        {details?.map((detail, idx) => (
          <React.Fragment key={idx}>
            {renderDetailElement(
              detail,
              consumerData,
              handlePreviewGeneralTerms
            )}
          </React.Fragment>
        ))}
      </div>
    </>
  );
};

const ConsumerDetails = () => {
  const dispatch = useDispatch();
  const [expanded, setExpanded] = useState("");
  // const { consumers, loading, error, consumerDetail } = useSelector(
  //   (state) => state.companyAdminSlice
  // );

  const { fetchSideBarConsumerList, loading, error } = useSelector(
    (state) => state.CapacitySlice
  );
  const consumerDetail = useSelector((state) => state.companyAdminSlice);

  const { handlePreviewGeneralTerms, PdfPreviewModal } = usePdfPreview();

  useEffect(() => {
    if (expanded) {
      window.scrollBy({ top: "-20px", behavior: "smooth" });
    }
  }, [expanded]);

  const handleChange = (consumerId) => {
    const isExpanding = expanded !== consumerId;
    setExpanded(expanded === consumerId ? false : consumerId);

    if (isExpanding) {
      dispatch(fetchConsumer(consumerId));
    }
  };

  const handleEdit = (e, id) => {
    e.stopPropagation();
    e.preventDefault();
  };

  if (loading) {
    return (
      <div className={Styles.detailsContainer}>
        <div style={{ padding: "20px", textAlign: "center" }}>
          Loading consumer details...
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className={Styles.detailsContainer}>
        <div style={{ padding: "20px", textAlign: "center", color: "red" }}>
          Error loading consumer details: {error}
        </div>
      </div>
    );
  }

  if (!fetchSideBarConsumerList || fetchSideBarConsumerList.length === 0) {
    return (
      <div className={Styles.detailsContainer}>
        <div style={{ padding: "20px", textAlign: "center" }}>
          No consumer details available
        </div>
      </div>
    );
  }

  return (
    <div className={Styles.detailsContainer}>
      {fetchSideBarConsumerList.map((consumer, idx) => {
        console.log(
          "🚀 ~ ConsumerDetails ~ consumerDetail?.consumerDetail?.data:",
          consumerDetail?.consumerDetail?.data?.consumerId
        );
        return (
          <div
            className={Styles.eachDetailSection}
            key={consumer.consumerId || idx}
          >
            <Accordion expanded={expanded === consumer.consumerId}>
              <AccordionSummary
                aria-controls={`panel${consumer.consumerId}d-content`}
                id={`panel${consumer.consumerId}d-header`}
              >
                <div className={Styles.eachDetailSectionContainer}>
                  {/* <div className={Styles.sectionHeading}>
                    <span>
                      {consumer.consumerName || consumerDetails?.heading}
                    </span>
                    <DriveFileRenameOutlineIcon
                      onClick={(e) => handleEdit(e, consumer.consumerId)}
                    />
                  </div> */}
                  {/* {renderDetailSection("", consumerDetails?.details, consumer)}
                  {renderDetailSection(
                    "Bank Details",
                    consumerDetails?.bankDetails,
                    consumer
                  )}
                  {renderDetailSection(
                    "Office Address",
                    consumerDetails?.consumerOfficeAddress,
                    consumer
                  )}
                  {renderDetailSection(
                    "Correspondence Address",
                    consumerDetails?.consumerCorrespondenceAddress,
                    consumer
                  )} */}
                  {/* <div
                    className={Styles.listingDetailsBtn}
                    onClick={() => handleChange(consumer.consumerId)}
                  >
                    <span>
                      {consumer.consumerName || consumerDetails?.heading} Listings
                      Activity
                    </span>
                    {expanded === consumer.consumerId ? (
                      <KeyboardDoubleArrowUpIcon style={{ fontSize: "18px" }} />
                    ) : (
                      <KeyboardDoubleArrowDownIcon style={{ fontSize: "18px" }} />
                    )}
                  </div> */}
                  <div
                    className={Styles.eachDetailSectionContainer}
                    onClick={() => handleChange(consumer.consumerId)}
                  >
                    <div className={Styles.sectionHeading}>
                      <span>
                        {consumer.consumerName ||
                          consumerDetailsConfig?.heading}
                      </span>
                      {/* <DriveFileRenameOutlineIcon
                        onClick={(e) => handleEdit(e, consumer.consumerId)}
                      /> */}
                    </div>
                  </div>
                </div>
              </AccordionSummary>
              <AccordionDetails>
                <div className={Styles.eachDetailSectionContainer}>
                  {expanded === consumer.consumerId &&
                  loading &&
                  !consumerDetail?.consumerDetail?.data ? (
                    <div style={{ padding: "20px", textAlign: "center" }}>
                      Loading consumer details...
                    </div>
                  ) : expanded === consumer.consumerId ? (
                    (() => {
                      const detailedData =
                        expanded === consumer.consumerId &&
                        consumerDetail?.consumerDetail?.data
                          ? consumerDetail?.consumerDetail?.data
                          : consumer;

                      return (
                        <>
                          {renderDetailSection(
                            "Consumer Details",
                            consumerDetailsConfig?.details,
                            detailedData,
                            handlePreviewGeneralTerms
                          )}
                          {renderDetailSection(
                            "Bank Details",
                            consumerDetailsConfig?.bankDetails,
                            detailedData,
                            handlePreviewGeneralTerms
                          )}
                          {renderDetailSection(
                            "Office Address",
                            consumerDetailsConfig?.consumerOfficeAddress,
                            detailedData,
                            handlePreviewGeneralTerms
                          )}
                          {renderDetailSection(
                            "Correspondence Address",
                            consumerDetailsConfig?.consumerCorrespondenceAddress,
                            detailedData,
                            handlePreviewGeneralTerms
                          )}
                          {renderDetailSection(
                            "Discom Details",
                            consumerDetailsConfig?.discomDetails,
                            detailedData,
                            handlePreviewGeneralTerms
                          )}
                        </>
                      );
                    })()
                  ) : null}
                </div>
              </AccordionDetails>
            </Accordion>
          </div>
        );
      })}
      {<PdfPreviewModal />}
    </div>
  );
};

export default ConsumerDetails;
